export type UserData = {
  companyCode: string;
  companyName: string;
  displayCompanyCode: string;
  displayCompanyName: string;
  userRole: string;
  id: string;
};

export const initUserData = {
  companyCode: "",
  companyName: "",
  displayCompanyCode: "",
  displayCompanyName: "",
  userRole: "",
  id: "",
};

export enum UserRole {
  YKC = "YKC",
  RENTAL = "RENTAL",
  Admin = "ADMIN",
  GENERAL = "GENERAL",
}

export const useSessionStorage = () => {
  // 情報取得
  const getUserData = (): UserData => {
    const temp = sessionStorage.getItem("userData");
    if (temp != null) {
      return JSON.parse(temp) as UserData;
    }
    return {
      companyCode: "",
      companyName: "",
      displayCompanyCode: "",
      displayCompanyName: "",
      id: "",
      userRole: UserRole.GENERAL,
    } as UserData;
  };

  // 編集・追加
  const setUserData = (userData: UserData) => {
    const temp = JSON.stringify(userData);
    sessionStorage.setItem("userData", temp);
  };

  // 削除
  const deleteUserData = () => {
    sessionStorage.removeItem("userData");
  };

  return { getUserData, deleteUserData, setUserData, initUserData };
};
